// extracted by mini-css-extract-plugin
export var header = "_t3-1";
export var maskBottom = "_t3-6";
export var maskMiddle = "_t3-7";
export var maskTop = "_t3-5";
export var root = "_t3-0";
export var scrollDownButton = "_t3-3";
export var scrollDownButtonHidden = "_t3-4";
export var viewport = "_t3-2";